import UserEdit from './UserEdit';

export default {
	edit: UserEdit,
};